import { useRef, useState } from "react";
import Button from "../../gui/Button/Button";
import Form, { useForm } from "../../gui/Form/Form";
import FormControl from "../../gui/Form/FormControl";
import Validators from "../../gui/Form/Validators";
import { useOverlay } from "../../gui/Overlay/OverlayProvider";
import TextInput, { ITextInput } from "../../gui/TextInput/TextInput";
import { FMFile } from "../../shared/FMFile";
import Files from "../../fmanlibs/Files";
import { useSnackbar } from "../../gui/Snackbar/SnackbarProvider";

const DIALOG_ID="rename"

function RenameDlg(props:{file:FMFile}) {
    const {popOverlay} = useOverlay()
    const {valid} = useForm()
    const [busy,setBusy] = useState<boolean>(false)
    const {addSnackbar} = useSnackbar()
    const filename = useRef<ITextInput|null>(null)
    const onClose = () => popOverlay(DIALOG_ID)
    const onSave = async () => {
        if (props.file.name.localeCompare(filename.current!.value!)==0) return popOverlay(DIALOG_ID)
        else if (busy) return
        else setBusy(true)
        try {
            await Files.i.renameFile(props.file._id, filename.current!.value!)
            popOverlay(DIALOG_ID)
        }catch(e){
            addSnackbar(e)
        }finally{
            setBusy(false)
        }
    }
    return <>
        <div className="header flex middle gap-8">
            <h2>Rename</h2> - <div className="grey-text medium-text ellipsis flex1">{props.file.name}</div>
        </div>
        <div className="content">
            <FormControl validators={[Validators.Required("Filename")]}>
                <TextInput placeholder="New filename" float={true} ref={filename}/>
            </FormControl>
        </div>
        <div className="actions">
            <Button size="medium" onClick={onClose}>Cancel</Button>
            <Button size="medium" disabled={!valid || busy} onClick={onSave}>Rename</Button>
        </div>
    </>
}

export default function useRenameDlg(){
    const {addOverlay,hasOverlay} = useOverlay()

    const rename = async (file:FMFile) => {
        if (hasOverlay(DIALOG_ID)) return
        else addOverlay(DIALOG_ID, {children:<Form><RenameDlg file={file}/></Form>, className:"dialog"})
    }
    return {rename}
}